import http from '@/utils/http'

export const createSchema = (nodeID, type, body = {}) => http.post(`/kuiper/${nodeID}/schemas/${type}`, body)

export const loadSchemasByType = (nodeID, type) => http.get(`/kuiper/${nodeID}/schemas/${type}`)
export const loadCustomSchemas = (nodeID) => http.get(`/kuiper/${nodeID}/schemas/custom`)
export const loadProtobufSchemas = (nodeID) => http.get(`/kuiper/${nodeID}/schemas/protobuf`)

export const deleteSchema = (nodeID, name, type) => http.delete(`/kuiper/${nodeID}/schemas/${type}/${name}`)
export const updateSchema = (nodeID, type, name, body = {}) => {
  return http.put(`/kuiper/${nodeID}/schemas/${type}/${name}`, body)
}
// TODO: support custom
export const viewSchema = (nodeID, name, type) => http.get(`/kuiper/${nodeID}/schemas/${type}/${name}`)

export default {}
